export default __webpack_public_path__ + "static/media/service_udp_24.4b956c32.svg";